<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="mx-auto col-12 col-md-8 col-lg-6">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Ubah Password</h6>
            <p class="text-sm mb-0">
              Masukkan password baru untuk akun <strong>{{ username }}</strong>.
            </p>
          </div>
          <div class="card-body">
            <label class="form-control-label">Password Baru</label>
            <argon-input
              type="password"
              placeholder="Minimal 6 karakter"
              v-model:value="password"
              name="password"
              size="lg"
              @keyup.enter="submit"
            />

            <label class="form-control-label">Konfirmasi Password Baru</label>
            <argon-input
              type="password"
              placeholder="Ulangi password baru"
              v-model:value="password_confirmation"
              name="password_confirmation"
              size="lg"
              @keyup.enter="submit"
            />

            <div class="mb-3" v-if="error != ''">
              <argon-alert color="danger">{{ error }}</argon-alert>
            </div>

            <argon-button
              variant="gradient"
              color="success"
              full-width
              size="lg"
              :disabled="loading"
              @click="submit"
            >{{ loading ? 'Menyimpan...' : 'Simpan Password' }}</argon-button>
          </div>
        </div>
      </div>
    </div>
    <auth-check></auth-check>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";
import AuthCheck from "@/components/authCheck.vue";

export default {
  name: "UbahPassword",
  components: {
    ArgonInput,
    ArgonButton,
    ArgonAlert,
    AuthCheck
  },
  data() {
    return {
      password: "",
      password_confirmation: "",
      error: "",
      loading: false
    };
  },
  computed: {
    username() {
      return this.$store.state.user ? this.$store.state.user.username : "";
    }
  },
  methods: {
    submit() {
      this.error = "";

      if (this.password.length < 6) {
        this.error = "Password baru minimal 6 karakter";
        return;
      }
      if (this.password !== this.password_confirmation) {
        this.error = "Konfirmasi password tidak cocok";
        return;
      }

      this.loading = true;
      this.axios
        .post(
          process.env.VUE_APP_API_URL + "change-password",
          {
            password: this.password,
            password_confirmation: this.password_confirmation
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token")
            }
          }
        )
        .then(() => {
          this.loading = false;
          this.password = "";
          this.password_confirmation = "";
          this.$toast.success("Password Berhasil Diubah");
        })
        .catch((resp) => {
          this.loading = false;
          this.error =
            resp.response && resp.response.data && resp.response.data.error
              ? resp.response.data.error
              : "Gagal mengubah password";
        });
    }
  }
};
</script>
